import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Actions as ActionsLayout } from '#src/atoms/layout/Actions/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, HeadlineS } from '#src/atoms/typography/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { messages } from '#src/components/settings/AcceptedCurrencies/messages.ts';
import { useIntlContext } from '#src/contexts/intl/index.ts';
import { AcceptedCurrenciesValue } from '#src/hooks/useAcceptedCurrencies.ts';

const Content = styled(Vertical).attrs({ gap: 3, center: true })`
  text-align: center;
  padding: var(--triple-unit);
`;

const Actions = styled(ActionsLayout).attrs({
  direction: 'vertical',
  gap: 1,
})`
  width: 100%;
`;

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  value?: AcceptedCurrenciesValue;
};

export const ConfirmationDialog = ({
  open,
  value,
  onConfirm,
  onCancel,
}: Props) => {
  const { formatMessage } = useIntlContext();
  const displayValue = () => {
    switch (value) {
      case AcceptedCurrenciesValue.BOTH:
        return formatMessage(messages.cashAndCrypto);
      case AcceptedCurrenciesValue.FIAT:
        return formatMessage(messages.fiat);
      case AcceptedCurrenciesValue.CRYPTO:
      default:
        return formatMessage(messages.crypto);
    }
  };
  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onCancel} hideHeader>
      <Content>
        <Vertical gap={2}>
          <HeadlineS as="h5" bold color="var(--c-white)">
            <FormattedMessage defaultMessage="Are you sure?" />
          </HeadlineS>
          <BodyM color="var(--c-white)">
            <FormattedMessage defaultMessage="This will only apply to future card listings, your current listings will follow previous payment settings." />
          </BodyM>
        </Vertical>
        <Actions>
          <Button fullWidth color="primary" size="medium" onClick={onConfirm}>
            <FormattedMessage
              defaultMessage="Yes, update to {value}"
              values={{
                value: displayValue(),
              }}
            />
          </Button>
          <Button fullWidth color="tertiary" size="medium" onClick={onCancel}>
            <FormattedMessage defaultMessage="No, go back" />
          </Button>
        </Actions>
      </Content>
    </Dialog>
  );
};
